import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  background-color: ${props => (props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.base) || '#ffffff'};
  border-radius: ${props => (props.theme.radii && props.theme.radii.lg) || '8px'};
  box-shadow: ${props => (props.theme.shadows && props.theme.shadows.sm) || '0 1px 2px 0 rgba(0, 0, 0, 0.05)'};
  border: 1px solid ${props => (props.theme.colors && props.theme.colors.border) || '#e5e7eb'};
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
`;

export const TH = styled.th`
  padding: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'} ${props => (props.theme.spacing && props.theme.spacing.lg) || '24px'};
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.sm) || '14px'};
  font-weight: 600;
  color: ${props => (props.theme.colors && props.theme.colors.text && props.theme.colors.text.muted) || '#6b7280'};
  background-color: ${props => (props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.muted) || '#f9fafb'};
  border-bottom: 1px solid ${props => (props.theme.colors && props.theme.colors.border) || '#e5e7eb'};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const TR = styled.tr`
  border-bottom: 1px solid ${props => (props.theme.colors && props.theme.colors.border) || '#e5e7eb'};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${props => (props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.muted) || '#f9fafb'};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TD = styled.td`
  padding: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'} ${props => (props.theme.spacing && props.theme.spacing.lg) || '24px'};
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.sm) || '14px'};
  color: ${props => (props.theme.colors && props.theme.colors.text && props.theme.colors.text.primary) || '#111827'};
  vertical-align: middle;
`;

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'} ${props => (props.theme.spacing && props.theme.spacing.lg) || '24px'};
  border-top: 1px solid ${props => (props.theme.colors && props.theme.colors.border) || '#e5e7eb'};
  gap: ${props => (props.theme.spacing && props.theme.spacing.xs) || '4px'};
`;

export const PaginationButton = styled.button`
  background: ${props => props.active ? ((props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || '#2563eb') : 'transparent'};
  color: ${props => props.active ? '#ffffff' : ((props.theme.colors && props.theme.colors.text && props.theme.colors.text.primary) || '#374151')};
  border: 1px solid ${props => props.active ? ((props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || '#2563eb') : ((props.theme.colors && props.theme.colors.border) || '#e5e7eb')};
  border-radius: ${props => (props.theme.radii && props.theme.radii.sm) || '4px'};
  padding: 4px 10px;
  cursor: pointer;
  font-weight: 500;
  
  &:hover:not(:disabled) {
    background-color: ${props => props.active ? ((props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || '#2563eb') : ((props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.muted) || '#f3f4f6')};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;



// WEBPACK FOOTER //
// ./src/design-system/molecules/TableData/components/TableDataStyles.js